// extracted by mini-css-extract-plugin
export var box = "WhatWeCanDoBox-module--box--2q_OG";